import React, { useState } from 'react';
import { Upload, X } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const ImageUploader = ({ value, onChange, label = "Зображення" }) => {
  const [uploading, setUploading] = useState(false);
  const [useUrl, setUseUrl] = useState(true);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Check file type
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'];
    if (!allowedTypes.includes(file.type)) {
      alert('Дозволені формати: JPG, PNG, GIF, WEBP, SVG');
      return;
    }

    // Check file size (5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('Файл занадто великий. Максимум 5MB');
      return;
    }

    setUploading(true);

    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(`${BACKEND_URL}/api/upload/image`, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        const data = await response.json();
        onChange(data.url);
      } else {
        alert('Помилка завантаження файлу');
      }
    } catch (error) {
      alert('Помилка завантаження');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ marginBottom: '15px' }}>
      <label style={{ color: '#ccc', display: 'block', marginBottom: '8px', fontSize: '14px' }}>{label}</label>
      
      {/* Toggle between URL and Upload */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
        <button
          type="button"
          onClick={() => setUseUrl(true)}
          style={{
            padding: '6px 12px',
            background: useUrl ? '#00ffff' : '#333',
            color: useUrl ? '#000' : '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '13px'
          }}
        >
          URL
        </button>
        <button
          type="button"
          onClick={() => setUseUrl(false)}
          style={{
            padding: '6px 12px',
            background: !useUrl ? '#00ffff' : '#333',
            color: !useUrl ? '#000' : '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '13px'
          }}
        >
          Завантажити файл
        </button>
      </div>

      {useUrl ? (
        <Input
          type="text"
          placeholder="https://example.com/image.jpg"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          style={{ background: '#222', border: '1px solid #444', color: '#fff' }}
        />
      ) : (
        <div>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileUpload}
            disabled={uploading}
            style={{
              display: 'block',
              width: '100%',
              padding: '10px',
              background: '#222',
              border: '1px solid #444',
              color: '#fff',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          />
          {uploading && (
            <p style={{ color: '#00ffff', fontSize: '13px', marginTop: '8px' }}>Завантаження...</p>
          )}
        </div>
      )}

      {/* Preview */}
      {value && (
        <div style={{ marginTop: '10px', position: 'relative', display: 'inline-block' }}>
          <img
            src={value}
            alt="Preview"
            style={{
              maxWidth: '200px',
              maxHeight: '150px',
              borderRadius: '8px',
              border: '2px solid #444'
            }}
          />
          <button
            type="button"
            onClick={() => onChange('')}
            style={{
              position: 'absolute',
              top: '5px',
              right: '5px',
              background: '#d32f2f',
              color: '#fff',
              border: 'none',
              borderRadius: '50%',
              width: '24px',
              height: '24px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <X size={14} />
          </button>
        </div>
      )}

      {/* Recommended sizes */}
      <p style={{ color: '#666', fontSize: '12px', marginTop: '8px' }}>
        {label === "Фото спікера" && "Рекомендовано: 400x400px або більше, співвідношення 1:1"}
        {label === "Логотип партнера" && "Рекомендовано: 200x80px, прозорий фон (PNG/SVG)"}
        {label.includes("зображення") && "Формат: JPG, PNG, GIF, WEBP, SVG (макс. 5MB)"}
      </p>
    </div>
  );
};

export default ImageUploader;
